import React, { useState } from "react";
import { apiProfileUpdatePhone, apiRequestEmailChange } from "../lib/api";

export default function ProfileEdit() {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [flash, setFlash] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function savePhone() {
    setError(null);
    setFlash(null);
    try {
      const r = await apiProfileUpdatePhone(phone);
      setFlash((r as any)?.status || "profile-updated");
    } catch (e: any) {
      setError(e?.message ?? "Failed to update phone");
    }
  }

  async function requestEmail() {
    setError(null);
    setFlash(null);
    try {
      const r = await apiRequestEmailChange(email);
      setFlash((r as any)?.message || "Email flow initiated");
    } catch (e: any) {
      setError(e?.message ?? "Failed to request email change");
    }
  }

  return (
    <div className="w-full px-6 card-box p-6 space-y-6">
      <h3 className="text-xl font-bold mb-2">Edit Profile</h3>

      {flash && <div className="alert-success">{flash}</div>}
      {error && <div className="alert-danger">{error}</div>}

      <div>
        <label className="block text-gray-700 mb-1">Mobile</label>
        <div className="flex items-center gap-2">
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            placeholder="+1xxxx"
          />
          <button className="btn" onClick={savePhone}>
            Save
          </button>
        </div>
      </div>

      <div>
        <label className="block text-gray-700 mb-1">Change email</label>
        <div className="flex items-center gap-2">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            placeholder="new@email.com"
          />
          <button className="btn btn-white" onClick={requestEmail}>
            Update
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-1">
          We’ll send a verification link to your new email.
        </p>
      </div>
    </div>
  );
}
